import type { CheckboxGroupType, SelectOptionType } from '~/presentation/reports/ui/type';
import type { IRItemCard, IRItemInfo } from '../types';

import { EReportChart } from '../../type';

export const GENERAL_VISUALIZATION_INFO: IRItemCard = {
  title: 'Visualization',
  content:
    'Charts, graphs, and other ways to display your data. Select “Recommended” to update the visualization dynamically based on your selected metrics and dimensions.',
  helps: [],
};

export const REPORT_VISUALIZATION_INFO: IRItemInfo = {
  [EReportChart.LINE]: {
    title: 'Line',
    content: 'Metric trend lines over time',
    helps: [
      'Spot seasonal trends and weekly patterns in your business performance',
      "Compare this year's performance against previous periods to measure growth",
    ],
  },
  [EReportChart.GROUP_BAR]: {
    title: 'Grouped bar',
    content:
      'Side-by-side bars clustered together for each category, letting you compare multiple values per category',
    helps: [
      'Contrast revenue vs profit across product lines',
      'Track new vs returning customer orders by month',
    ],
  },
  [EReportChart.SIMPLE_BAR]: {
    title: 'Simple bar',
    content: 'Comparison of single values across different categories',
    helps: [
      'Compare sales numbers for individual products or categories',
      'Compare monthly sales totals',
    ],
  },
};

export const CHART_LABELS = {
  [EReportChart.LINE]: 'Line',
  [EReportChart.GROUP_BAR]: 'Grouped bar',
  [EReportChart.SIMPLE_BAR]: 'Simple bar',
};

export const LINEAR_OPTIONS: SelectOptionType[] = [
  {
    label: CHART_LABELS[EReportChart.LINE],
    value: EReportChart.LINE,
  },
];

export const BAR_OPTIONS: SelectOptionType[] = [
  {
    label: CHART_LABELS[EReportChart.SIMPLE_BAR],
    value: EReportChart.SIMPLE_BAR,
  },
  {
    label: CHART_LABELS[EReportChart.GROUP_BAR],
    value: EReportChart.GROUP_BAR,
  },
];

export const REPORT_VISUALIZATION_GROUP: CheckboxGroupType = [
  {
    title: 'Linear',
    options: LINEAR_OPTIONS,
  },
  {
    title: 'Vertical bar',
    options: BAR_OPTIONS,
  },
];

export const CHART_OPTIONS = [
  { label: CHART_LABELS[EReportChart.LINE], value: EReportChart.LINE },
  { label: CHART_LABELS[EReportChart.GROUP_BAR], value: EReportChart.GROUP_BAR },
  { label: CHART_LABELS[EReportChart.SIMPLE_BAR], value: EReportChart.SIMPLE_BAR },
];
